import type { Area } from "@squire/core";
import { h } from "./dom.js";

/** First run, after the creator: four quick questions place the player in each area. */
const QUESTIONS: { area: Area; title: string; options: [string, number][] }[] = [
  {
    area: "body",
    title: "Ruch i sport",
    options: [
      ["Prawie wcale", 1],
      ["Czasem się ruszam", 3],
      ["Trenuję regularnie", 6],
      ["Trenuję od lat", 9],
    ],
  },
  {
    area: "mind",
    title: "Czytanie i nauka",
    options: [
      ["Rzadko", 1],
      ["Od czasu do czasu", 3],
      ["Regularnie", 6],
      ["Codziennie, od lat", 9],
    ],
  },
  {
    area: "work",
    title: "Praca i projekty",
    options: [
      ["Dopiero zaczynam", 1],
      ["Trochę doświadczenia", 3],
      ["Kilka lat w tym siedzę", 6],
      ["Jestem ekspertem", 9],
    ],
  },
  {
    area: "social",
    title: "Ludzie i spotkania",
    options: [
      ["Raczej sam", 1],
      ["Czasem kogoś widuję", 3],
      ["Regularnie się spotykam", 6],
      ["Dusza towarzystwa", 9],
    ],
  },
];

export function openStart(root: HTMLElement): Promise<Partial<Record<Area, number>>> {
  return new Promise((resolve) => {
    const picked: Partial<Record<Area, number>> = {};
    const rows = QUESTIONS.map((q) => {
      const buttons = q.options.map(([label, level]) => {
        const b = h("button", { "aria-pressed": "false" }, label);
        b.onclick = () => {
          picked[q.area] = level;
          for (const o of buttons) {
            o.className = o === b ? "primary" : "";
            o.setAttribute("aria-pressed", String(o === b));
          }
        };
        return b;
      });
      return h(
        "div",
        { style: { marginBottom: "0.9em" } },
        h("div", { class: "pixel", style: { marginBottom: "0.4em" } }, q.title),
        h("div", { style: { display: "flex", gap: "0.5em", flexWrap: "wrap" } }, ...buttons),
      );
    });
    const done = h("button", { class: "primary" }, "Gotowe");
    const skip = h("button", { class: "ghost" }, "Pomiń, zaczynam od zera");
    const overlay = h(
      "div",
      { class: "overlay" },
      h(
        "div",
        { class: "frame" },
        h("h1", { style: { marginBottom: "0.4em" } }, "Skąd startujesz?"),
        h(
          "p",
          { style: { fontSize: "0.9rem", marginBottom: "1em" } },
          "Mało kto zaczyna od zera. Zaznacz, jak jest teraz, a postać i mieszkanie od razu to pokażą. Później nic nie spada.",
        ),
        ...rows,
        h(
          "div",
          { style: { display: "flex", gap: "0.8em", justifyContent: "flex-end", marginTop: "1em" } },
          skip,
          done,
        ),
      ),
    );
    const close = (r: Partial<Record<Area, number>>) => {
      overlay.remove();
      resolve(r);
    };
    done.onclick = () => close(picked);
    skip.onclick = () => close({});
    root.append(overlay);
  });
}
